import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ContactRoutingModule } from './contact-routing.module';
import { WidgetsModule } from '../../widgets/widgets.module';
import { RecentNotesEffects } from '../../tamalelibs/redux/thread-list.effects';
import { ContactComponent } from './contact.component';
import { StoreModule } from '@ngrx/store';

import { entityReducer } from '../../tamalelibs/redux/entity.reducer';
import { ContactScreenModule } from '../../components/contact-screen/contact-screen.module';

@NgModule({
    imports: [
        CommonModule,
        ContactScreenModule,
        WidgetsModule,
        ContactRoutingModule,
        StoreModule.forFeature('entity', entityReducer),
        EffectsModule.forFeature([RecentNotesEffects
        ]),
    ],
    declarations: [
        ContactComponent
    ],
    exports: [
        ContactComponent
    ]

})
export class ContactModule { }
